import { useId, useState } from "react";

import faq from "~/i18n/faq";
import { useT } from "~/i18n/useT";

import "./Faq.scss";

export default function Faq() {
  const t = useT(faq);
  const [open, setOpen] = useState(0);
  const baseId = useId();

  return (
    <section className="ss-section ss-container ss-container--narrow">
      <div className="ss-heading ss-heading--center">
        <div>
          <p className="ss-eyebrow">{t.eyebrow}</p>
          <h2 className="ss-h2 ss-heading__title">{t.title}</h2>
        </div>
      </div>

      <div className="ss-faq">
        {t.items.map((item, index) => {
          const expanded = open === index;
          const panelId = `${baseId}-panel-${index}`;
          const buttonId = `${baseId}-button-${index}`;

          return (
            <div key={item.q} className="ss-faq__item">
              <h3 className="ss-faq__q">
                <button
                  type="button"
                  id={buttonId}
                  className="ss-faq__trigger"
                  aria-expanded={expanded}
                  aria-controls={panelId}
                  onClick={() => setOpen(expanded ? -1 : index)}
                >
                  <span>{item.q}</span>
                  <span className="ss-faq__icon" aria-hidden="true">
                    +
                  </span>
                </button>
              </h3>
              {/* Animated via grid-template-rows rather than `hidden`, which
                  cannot transition. `visibility` still hides the collapsed
                  answer from assistive tech and from tab order. */}
              <div
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
                className={`ss-faq__panel${expanded ? " is-open" : ""}`}
              >
                <div className="ss-faq__panel-inner">
                  <p>{item.a}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
